import React from 'react';


interface LazyWrapperProps {
  children: React.ReactNode
}


const SuspenseLoading = () => {
  return <div></div>;
};
const LazyWrapper: React.FC<LazyWrapperProps> = props => {
  return (
    <React.Suspense fallback={<SuspenseLoading />}>
      {props.children}
    </React.Suspense>
  );
};

export default LazyWrapper;